import React from "react"
import { useTranslation } from "react-i18next"
import HorizontalCardLayout from "../common/HorizontalCardLayout"

const Strategies = () => {
  const { t } = useTranslation()

  return (
    <section className="mx-auto max-w-7xl p-8 space-y-4 bg-blue-100">
      <h2 className="text-xl md:text-2xl font-semibold">
        {t("introvert-empowerment.strategies.title")}
      </h2>
      <div className="py-5">
        <HorizontalCardLayout
          cards={t("introvert-empowerment.strategies.strategies", {
            returnObjects: true,
          })}
        />
      </div>
    </section>
  )
}

export default Strategies
